<nav class="mt-3" *ngIf="totalPages > 1">
    <ul class="pagination justify-content-end">
      <li class="page-item" [ngClass]="{'disabled': currentPage == 0}">
        <a class="page-link" href="javascript: void(0);"  (click)="goToPage(currentPage-1)" tabindex="-1" aria-disabled="true">Anterior</a>
      </li>
       <!-- <ng-container  *ngFor="let index of arrayPagination">
         <li class="page-item" [ngClass]="{'active': index.isCurrent}" >
           <span class="page-link" *ngIf="index.isCurrent">{{ index.page + 1}}</span>
           <a class="page-link" href="javascript: void(0);"  *ngIf="!index.isCurrent" (click)="goToPage(index.page)">{{ index.page + 1 }}</a>
         </li>
         
       </ng-container> -->
       <ng-container  *ngFor="let index of arrayPagination">
         <li class="page-item" [ngClass]="{'active': index == currentPage}" *ngIf="showPage(index)">
           <span class="page-link" *ngIf="index == currentPage">{{ index + 1 }}</span>
           <a class="page-link" href="javascript: void(0);"  *ngIf="index != currentPage " (click)="goToPage(index)">{{ index + 1 }}</a>
         </li>
         <li class="page-item disabled" *ngIf="!showPage(index) && showDots(index)">
           <span class="page-link" >...</span>
         </li>
       </ng-container>
      <li class="page-item" [ngClass]="{'disabled': currentPage == totalPages-1}">
        <a class="page-link" href="javascript: void(0);"  (click)="goToPage(currentPage+1)">Siguiente</a>
      </li>
    </ul>
  </nav>